// How a reminder's fire time reads in a glance list: a clock time when
// it falls today (in the viewer's zone), a short weekday otherwise, and
// nothing for an unparseable timestamp.
export function reminderWhenLabel(fireAt: string, now: Date = new Date()): string {
  const at = new Date(fireAt)
  if (Number.isNaN(at.getTime())) return ''
  if (at.toDateString() === now.toDateString()) {
    return at.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  }
  return at.toLocaleDateString([], { weekday: 'short' })
}
